<template>
<div class="login">
  <div class="login__trama"></div>
  <div class="login__wrapper">
    <transition name="fade" mode="out-in">
      <component :is="currentView"
        @forgotPass="currentView='RecoverPass'"
        @initSession="currentView='SignIn'"/>
    </transition>
  </div>
</div>
</template>

<script>
import SignIn from '@/components/login/Login__sign'
import RecoverPass from '@/components/login/Login__recover'

export default {
  components: {
    SignIn,
    RecoverPass
  },
  data() {
    return {
      currentView: 'SignIn'
    }
  }
}
</script>

<style lang="scss">
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

.login{
  height: 100%;
  position: relative;
  &__trama{
    @include mq($md){
      height: 100%;
      width: 50%;
      position: absolute;
      top: 0;
      left: 0;
      background-image: bimg('banner.jpg');
      background-position: center center;
      background-size: cover;
    }
  }
  &__wrapper{
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @include mq($md){
      width: 50%;
      position: absolute;
      top: 0;
      right: 0;
    }
  }

}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
